import ScanConfigs from './scans/ScansConfig.js'
var prodConfig = require.context('../api', true, /\.js$/)
var ProjectConfig = ScanConfigs(prodConfig)
export default ProjectConfig
